<template>
  <h2 class="text-center mt-4">Camera Streaming</h2>
  <button
    @click="toggleStream"
    class="btn"
    :disabled="!videoTrack || !cameras.length"
    :class="isStreaming ? 'btn-danger' : 'btn-primary'"
  >
    {{ isStreaming ? "Stop Streaming" : "Start Streaming" }}
  </button>
  <div class="d-flex justify-content-center mt-3">
     <video id="local-player" autoplay width="640" height="360" class="border rounded shadow"></video>
   </div>

  <div class="container mt-3" style="max-width: 540px;">
    <div class="d-flex justify-content-start align-items-center gap-2 mt-3">
      <label for="cameraSelect" class="fw-bold" style="width:120px">Choose Camera:</label>
      <select id="cameraSelect" v-model="selectedCamera" @change="switchCamera" class="form-select w-auto">
        <option v-for="camera in cameras" :key="camera.deviceId" :value="camera.deviceId">
          {{ camera.label || "Camera " + (cameras.indexOf(camera) + 1) }}
        </option>
      </select>

      <label for="audio" class="fw-bold">Audio:</label>
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" id="toggleAudio" v-model="isAudioEnabled">
      </div>
    </div>

    <div class="d-flex justify-content-start align-items-center gap-2 mt-3">
      <label class="form-label mb-0 fw-bold" style="width:120px">Enable Recording:</label>

      <input
        type="text"
        class="form-control"
        style="max-width: 300px;"
        :disabled="isRecordingEnabled"
        v-model="subscribeUids"
        placeholder="Enter UIDs to record"
      >

      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" id="toggleRecording" v-model="isRecordingEnabled" :disabled="subscribeUids === ''">
      </div>
    </div>

    <div class="d-flex justify-content-start align-items-center gap-2 mt-3">
      <label class="form-label mb-0 fw-bold" style="width:120px">Gamepad Sensors:</label>
      <button @click="saveGamepadSensorAlias" class="btn btn-success">Save Aliases</button>
    </div>
    <table class="table table-hover table-bordered text-center mt-3">
      <thead class="table-dark">
        <tr>
          <th>ID</th>
          <th>Alias</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody id="gamepadSensorsTable">
        <tr v-for="[key, value] in sortedGamepadSensors" :key="key">
          <td>{{ key }}</td>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="value.alias"
              placeholder="Enter alias"
            >
          </td>
          <td>{{ value.value }}</td>
        </tr>
      </tbody>
    </table>
    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 9999;">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast show mb-2 text-white"
        :class="toast.type"
        role="alert"
      >
        <div class="toast-body">
          <h3>{{ toast.message }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgoraRTC from 'agora-rtc-sdk-ng';
import { RTM } from "agora-rtm-sdk";

let toastId = 0

export default {
  data() {
    return {
      cameraUid: 1000,
      roomId: '',
      secretId: '',
      secretKey: '',
      videoTrack: null,
      audioTrack: null,
      cameras: [],
      toasts: [],
      selectedCamera: null,
      isStreaming: false,
      rtcClient: null,
      gamepadSensors: {},
      gamepadSensorsAliases: JSON.parse(localStorage.getItem('gamepadSensorsAliases')) || {},
      subscribeUids: localStorage.getItem('subscribeUids') || '',
      isRecordingEnabled: localStorage.getItem('isRecordingEnabled') === 'true' || false,
      recordingInProgress: false,
      isAudioEnabled: false,
      recordingTimer: null,
      existSubscribeUids: [],
      apiUrl: '',
      rtm: null,
    };
  },
  watch: {
    isRecordingEnabled(newValue) {
      if (newValue) {
        localStorage.setItem('subscribeUids', this.subscribeUids);
        localStorage.setItem('isRecordingEnabled', true);
      } else {
        localStorage.removeItem('subscribeUids');
        localStorage.setItem('isRecordingEnabled', false);
      }
    }
  },
  computed: {
    sortedGamepadSensors() {
      return Object.entries(this.gamepadSensors).sort((a, b) =>
        a[0].localeCompare(b[0])
      )
    }
  },
  async mounted() {
    await this.getCameras();
    setInterval(() => {
      const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
      for (let i = 0; i < gamepads.length; i++) {
        const gp = gamepads[i];
        if (gp) {
          for (let j = 0; j < 4; j++) {
            if (gp.buttons[j].pressed) {
              const key = `Sensor ${j + 1}`;
              if (!this.gamepadSensors[key]) {
                const alias = this.gamepadSensorsAliases[key] ? this.gamepadSensorsAliases[key].alias : '';
                this.gamepadSensors[key] = { alias: alias, value: gp.buttons[4].pressed };
              } else {
                this.gamepadSensors[key].value = gp.buttons[4].pressed;
              }
              if (gp.buttons[4].pressed) {
                this.addToast(`${key}, (Robot ${this.gamepadSensors[key].alias}) Detected`, 'bg-success');
                if (this.rtm) {
                  const message = {'bot': this.gamepadSensors[key].alias, 'punch': gp.buttons[4].pressed};
                  console.log(message)
                  this.rtm.publish('punch', JSON.stringify(message));
                 }
              }
              break;
            }
          }
	}
      }
    }, 100);
  },
  async created() {
    this.secretId = this.$USER.secretId;
    this.secretKey = this.$USER.secretKey;
    this.roomId = this.$USER.roomId;
    this.apiUrl = '/api/room/' + this.roomId + '?secret_id=' + this.secretId + '&secret_key=' + this.secretKey + '&user_id=' + this.cameraUid;
    this.rtcClient = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
    this.videoTrack = await AgoraRTC.createCameraVideoTrack();
    this.switchCamera()
  },
  methods: {
    addToast(message, type = 'bg-primary') {
      const id = toastId++
      this.toasts.push({ id, message, type })

      setTimeout(() => {
        this.toasts = this.toasts.filter(t => t.id !== id)
      }, 3000)
    },
    async getCameras() {
      this.cameras = await AgoraRTC.getCameras();
      if (this.cameras.length > 0) {
        this.selectedCamera = this.cameras[0].deviceId;
      }
    },
    async switchCamera() {
      if (!this.videoTrack) return;

      await this.videoTrack.setDevice(this.selectedCamera);
      console.log("Switch camera to", this.selectedCamera);
    },
    toggleStream() {
      this.isStreaming = !this.isStreaming;
      if (this.isStreaming) {
        this.startStream();
      } else {
        this.stopStream();
      }
    },
    async saveGamepadSensorAlias() {
      localStorage.setItem('gamepadSensorsAliases', JSON.stringify(this.gamepadSensors));
      alert('Gamepad sensors aliases saved successfully!');
    },
    async stopStream() {
      this.videoTrack.setEnabled(false);
      if (this.rtcClient) {
        this.rtcClient.leave();
      }
    },
    async restartStream() {
      console.log('Restarting stream after 5 seconds...');
      setTimeout(async () => {
        if (this.isStreaming) {
          console.log('Restarting stream...');
          await this.startStream();
        }
      }, 5000);
    },
    getUTCDateTimeString() {
      const now = new Date();
      const year = now.getUTCFullYear();
      const month = String(now.getUTCMonth() + 1).padStart(2, '0');
      const day = String(now.getUTCDate()).padStart(2, '0');
      const hours = String(now.getUTCHours()).padStart(2, '0');
      const minutes = String(now.getUTCMinutes()).padStart(2, '0');
      const seconds = String(now.getUTCSeconds()).padStart(2, '0');
      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    },
    async stopRecording() {
      // stop by delete
      const recordingUrl = '/api/v1/recording/' + this.roomId;
      const response = await fetch(recordingUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + btoa(this.secretId + ':' + this.secretKey),
        },
      });
      if (response.ok) {
        const data = await response.json();
        console.log('Recording stopped:', data);
        this.recordingInProgress = false;
      } else {
        console.error('Error stopping recording:', response.statusText);
      }
    },
    async startRecording() {
      // start by post
      const recordingUrl = '/api/v1/recording/' + this.roomId;
      const recordingDetails = {
        bucket: 'ufb-data',
        subscribe_audio_uids: [],
        subscribe_video_uids: [],
        file_name_prefix: [this.roomId, this.getUTCDateTimeString()],
      };
      const response = await fetch(recordingUrl, {
        method: 'POST',
        headers: {
          'Authorization': 'Basic ' + btoa(this.secretId + ':' + this.secretKey),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(recordingDetails),
      });
      if (response.ok) {
        const data = await response.json();
        console.log('Recording started:', data);
        this.recordingInProgress = true;
      } else {
        console.error('Error starting recording:', response.statusText);
      } 
    },
    async startStream() {
      this.videoTrack.setEnabled(true);
      const token = await fetch(this.apiUrl)
                            .then(data => data.json())
                            .catch(err => {
                              console.log(err);
                              this.restartStream();
                            });
      if (token === undefined) {
        return;
      }

      const rtcToken = token.rtc_token;
      const rtmToken = token.rtm_token;
      const appId = this.$APP_ID
      const channel = this.roomId

      const rtm = new RTM(appId, this.roomId + "-" + this.cameraUid)
      rtm.addEventListener("status", (event) => {

        const currentState = event.state;
        const changeReason = event.reason;
        console.log(JSON.stringify(event));

        if (currentState === "CONNECTED") {
          console.log("RTM Connected");
          this.rtm = rtm;
            setTimeout(() => {
              rtm.subscribe('punch')
            }, 500);

        }
        if (changeReason === "TOKEN_EXPIRED") {
          console.log("RTM Token expired, requesting a new token...");
        } else if (changeReason === "SAME_UID_LOGIN") {
          console.log("RTM Same UID login, disconnecting...");
        }

      });
      const result = await rtm.login({ token: rtmToken });
      console.log("RTM Login:", result);

      this.rtcClient.on("user-published", async (user, mediaType) => {
        console.log("user-published: ", user, mediaType);
      });

      this.rtcClient.on('user-joined', async (user) => {
        console.log('user-joined: ' + user.uid);
        if (this.isRecordingEnabled) {
          const subscribeUids = this.subscribeUids.split(',').map(uid => parseInt(uid.trim()));
          if (subscribeUids.includes(user.uid)) {

            if (this.recordingTimer) {
              clearTimeout(this.recordingTimer);
              this.recordingTimer = null;
            }
            if (!this.recordingInProgress) {
              console.log('Starting recording...');
              //this.recordingInProgress = true;
              await this.startRecording();
            }
          }
        }
      });

      this.rtcClient.on('user-left', async (user) => {
        console.log('user-left: ' + user);
        if (this.isRecordingEnabled && this.recordingInProgress) {
          const subscribeUids = this.subscribeUids.split(',').map(uid => parseInt(uid.trim()));
          // create a array with remoteUsers uid
          const remoteUids = this.rtcClient.remoteUsers.map(user => user.uid);
          // stop if remoteUids not include subscribeUids
          if (!subscribeUids.some(uid => remoteUids.includes(uid))) {
            console.log('Stopping recording after 60 seconds...');
            this.recordingTimer = setTimeout(() => {
              console.log('Stopping recording...');
              this.stopRecording();
              //this.recordingInProgress = false;
            }, 60000);
          } else {
            console.log('Recording is still in progress for other UIDs');
          }
        }
      });

      this.rtcClient.on('user-unpublished', async (user, mediaType) => {
        console.log('user-unpublished: ' + user, mediaType);
      });

      this.rtcClient.on('connection-state-change', async (curState) => {
        console.log('connection-state-change: ' + curState);
        if (curState === 'CONNECTED') {
          console.log('Connected to Agora');
          this.videoTrack.play('local-player');
          if (this.isAudioEnabled) {
            this.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
            this.audioTrack.setEnabled(true);
            let localTrack = {
              videoTrack: this.videoTrack,
              audioTrack: this.audioTrack,
            };
            await this.rtcClient.publish(Object.values(localTrack));
          } else {
            await this.rtcClient.publish(this.videoTrack);
          }
        } else if (curState === 'DISCONNECTED') {
          console.log('Disconnected from Agora');
          this.videoTrack.stop();
          if (this.isStreaming) {
            this.restartStream();
          }
        }
      });

      this.rtcClient.on("token-privilege-will-expire", async () => {
        // After requesting a new token
        console.log("Token will expire, requesting a new token...");
        const token = await fetch(this.apiUrl)
                              .then(data => data.json())
                              .catch(err => {
                                console.log(err);
                              });
        if (token !== undefined) {
          const rtcToken = token.rtc_token;
          const rtmToken = token.rtm_token;
          await this.rtcClient.renewToken(rtcToken);
          await this.rtm.renewToken(rtmToken);
        }
      });

      const uid = await this.rtcClient.join(appId, channel, rtcToken, this.cameraUid);
      console.log("uid: ", uid);
    },
  }
};
</script>

<style>
.toast {
  min-width: 200px;
  border-radius: 0.5rem;
}
</style>
